import React from 'react';
import styled from 'styled-components';
import { Body1, Body5, Container, Page } from '@ui';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { TransparentFlatButton } from '@ui/buttons';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { Working } from '@ui/Working';

const ListWrapper = styled.table`
  margin: 0;
  border-collapse: collapse;
  width: 100%;

  td {
    cursor: pointer;
    padding: 8px 16px;
    border-bottom: 1px solid ${({ theme }) => theme.themeColors.border};
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

export const MemoryKeyList = ({ keys, loadingKeys, onViewKey, onRegisterKey, onGoBack }) => {
  return (
    <Page>
      <BackArrowButton onClick={onGoBack} />
      <Container top={40}>
        <Body1 bold>Memory Keys</Body1>
        {loadingKeys && <Working />}
        <Container top={16}>
          <ListWrapper>
            <tbody>
              {keys.map((key) => (
                <tr key={key}>
                  <td style={{ width: '100%' }} onClick={() => onViewKey(key)}>
                    <Body5 bold>{key}</Body5>
                  </td>
                  <td>
                    <TransparentFlatButton onClick={() => onViewKey(key)}>View</TransparentFlatButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </ListWrapper>
        </Container>
        <Container top={24}>
          <SkeletonButton fullWidth onClick={onRegisterKey}>
            Register New Key
          </SkeletonButton>
        </Container>
      </Container>
    </Page>
  );
};
